<button (click)="emitToggle()" [class.is-disabled]="disabled" data-ui-name="Emit Toggle" data-ui-component="check-toggle" data-testid="check-toggle-emit-toggle">
  <i *ngIf="!isChecked" class="is-unchecked far fa-circle" aria-hidden="true"></i>
  <i *ngIf="isChecked"  class="is-checked fa fa-check-circle" aria-hidden="true"></i>
</button>